import { get } from '@/httpRequest'

export interface IGroupListRequest {
  /**
   * 资源id
   */
  resource_id?: string
  /**
   * 资源类型，1Novel,2AdNovel,3剧集,4书单
   */
  resource_type?: string
}

export interface IGroupListResponse {
  count: number
  list: IGroupListItem[]
}

export interface IGroupListItem {
  id: string
  session_type: number
  session_id: string
  session_name: string
  session_avatar_url: string
  last_message_type: number
  last_message_content: string
  last_message_created_at: number
  last_read_at: null | number
  last_message_sender_id: string
  preFix?: string
}

export const getGroupList = async (params: IGroupListRequest) => {
  const response = await get<IGroupListResponse>(
    `/imApi/group/listByAdmin`,
    params
  )

  return response
}
